module.exports = "https://static.energy5.com/_next/static/images/userFriendly-bf60e16ca9ca4f025f5bc02ae1d579ec.png";